import { createFileRoute } from '@tanstack/react-router'
import { WatchedWalletsList } from '../features/wallets/WatchedWalletsList'

export const Route = createFileRoute('/_auth/wallets/watched')({
  component: WatchedWalletsList,
})
